import { Component, Input, HostListener } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  templateUrl: './dangerZoneModal.component.pug',
})
export class DangerZoneModalComponent {
  @Input() message: string

  constructor (public modal: NgbActiveModal) { }

  @HostListener('document:keyup.enter')
  private onEnter () {
    this.modal.close()
  }

  @HostListener('document:keyup.space')
  private onSpace () {
    this.modal.close()
  }

  @HostListener('document:keydown.escape')
  private onEscape () {
    this.modal.dismiss()
  }
}
